// extracted by mini-css-extract-plugin
export var labelWrapper = "_ej-0";